export default __webpack_public_path__ + "static/media/m_engineering_card04_1.d96ef4b3.png";